<template>
  <div>asdfjhasdlfjhaslf</div>
</template>
<script>
import {fetch2} from '@/modules/configuration.js';
export default {
  data() {
    return {
      loading: true,
      data: {}
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      fetch2(this, "/not_found").then(data => {
        this.data = data;
        this.loading = false;
      });
    },
  }
}
</script>